import ForwardIcon from "@/assets/icons/forward.svg";
import ReplyToAllIcon from "@/assets/icons/reply-all.svg";
import ReplyIcon from "@/assets/icons/reply.svg";
import MailActionType from "@/domain/enums/MailActionType";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../ui/select";

type messageTypeSelectProps = {
    messageType: MailActionType;
    setMessageType: (messageType: MailActionType) => void;
};

const MessageTypeSelect = ({
    messageType,
    setMessageType,
}: messageTypeSelectProps) => (
    <Select onValueChange={setMessageType} value={messageType}>
        <SelectTrigger className="h-auto min-w-0 rounded-full border-none p-1 shadow-none focus:ring-0 focus:ring-offset-0">
            <SelectValue placeholder="" />
        </SelectTrigger>
        <SelectContent className="min-w-0">
            <SelectItem value={MailActionType.REPLY}>
                <img alt="Répondre" className="h-4 w-4" src={ReplyIcon} />
            </SelectItem>
            <SelectItem value={MailActionType.REPLY_ALL}>
                <img
                    alt="Répondre à tous"
                    className="h-4 w-4"
                    src={ReplyToAllIcon}
                />
            </SelectItem>
            <SelectItem value={MailActionType.FORWARD}>
                <img alt="Transférer" className="h-4 w-4" src={ForwardIcon} />
            </SelectItem>
        </SelectContent>
    </Select>
);

export default MessageTypeSelect;
